/* esm.sh - @emotion/is-prop-valid@1.4.0 */
export * from "/*@emotion/is-prop-valid@1.4.0/esnext/is-prop-valid.mjs";
export { default } from "/*@emotion/is-prop-valid@1.4.0/esnext/is-prop-valid.mjs";
